import React from 'react';
import { View, Text, StyleSheet } from 'react-native';

const ErrorMessage = ({ visible, message }) => {
    // console.log("MESSAGE", message)
  if (!visible) return null;

  return (
    <View style={styles.container}>
      <Text style={styles.text}>{message}</Text>
    </View>
  );
};

const SuccessMessage = ({ visible, message }) => {
  // console.log("MESSAGE", message)
if (!visible) return null;

return (
  <View style={styles.container_success}>
    <Text style={styles.text}>{message}</Text>
  </View>
);
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: '#f00', // Color de fondo rojo para indicar un error
    padding: 10,
    marginVertical: 10,
  },
  container_success: {
    backgroundColor: '#178935', // Color de fondo rojo para indicar un error
    padding: 10,
    marginVertical: 10,
  },
  text: {
    color: '#fff', // Texto blanco para el mensaje de error
  },
  
});

export {ErrorMessage,SuccessMessage};